<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <v-row>
          <v-col cols="12" sm="12">
            <v-row>
              <v-col cols="12" sm="4">
                <v-card elevation="7" @click="showDataAll()">
                  <v-card-text>
                    <div class="text-center">
                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-icon color="#B61C1C" size="50" > mdi-text-box-search </v-icon>
                          <br />
                          <p> ทั้งหมด </p>
                          <v-alert dark dense border="left" color="#B61C1C">
                            จำนวน : {{ number }}
                          </v-alert>
                        </v-col>
                      </v-row>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" sm="8">
                <v-row>
                  <v-col cols="12" sm="3" v-for="(items, index) in dataPosition" :key="index">
                    <v-card elevation="7" @click="showDataByPosition(items.positionName)">
                      <v-card-text>
                        <div class="text-center">
                          <v-row>
                            <v-col cols="12" sm="12">
                              <v-icon color="#262A34" size="50" > mdi-account-group </v-icon>
                              <br />
                              <p> {{ items.positionName }} </p>
                              <div >
                                <v-alert dark dense border="left" color="#262A34" v-if="items.AppyRegister == null">
                                  0
                                </v-alert>
                                <v-alert dark dense border="left" color="#262A34" v-else>
                                  {{ items.AppyRegister }}
                                </v-alert>
                              </div>
                            </v-col>
                          </v-row>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="12">
                <v-btn
                  color="success"
                  dark
                  @click="exportToExcelAll"
                >
                  Excel download
                </v-btn>
              </v-col>
              <!-- data table -->
              <v-col>
                <v-card elevation="7" v-if="dataReady">
                  <v-card-text>
                    <v-data-table
                      :headers="columns"
                      :items="dataItem"
                      :items-per-page="10"
                    >
                      <template v-slot:[`item.CREATE_DATE`]="{ item }">
                        {{ format_date(item.CREATE_DATE) }}
                      </template>
                      <template v-slot:[`item.LAST_DATE`]="{ item }">
                        {{ format_date(item.LAST_DATE) }}
                      </template>
                      <template v-slot:[`item.action`]="{ item }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="question"
                              fab
                              small
                              v-bind="attrs"
                              v-on="on"
                              @click.stop="(dialog = true), getDataById(item)"
                            >
                              <v-icon dark> mdi-account-box </v-icon>
                            </v-btn>
                          </template>
                          <span> ดูข้อมูลผู้สมัคร </span>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
                <div v-if="!dataReady" class="text-center">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </div>
              </v-col>

              <!-- รายละเอียดผู้สมัคร -->
              <v-dialog
                v-model="dialog"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
              >
                <v-card>
                  <v-toolbar
                    dark
                    color="#B61C1C"
                  >
                    <v-btn
                      icon
                      dark
                      @click="dialog = false"
                    >
                      <v-icon> mdi-close </v-icon>
                    </v-btn>
                    <v-toolbar-title> ข้อมูลผู้สมัคร </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                      <v-btn
                        dark
                        text
                        @click="exportToExcel"
                      >
                        Export Data
                      </v-btn>
                    </v-toolbar-items>
                  </v-toolbar>
                  <v-list
                    three-line
                    subheader
                  >
                    <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-expansion-panels v-model="panel" multiple>
                            <!-- ประวัติผู้สมัคร -->
                            <v-expansion-panel>
                              <v-expansion-panel-header>
                                <v-row no-gutters>
                                  <v-col cols="12">
                                    <v-icon left color="#808588"> mdi-account-circle </v-icon>
                                    <strong class="Color-Font"> ประวัติผู้สมัคร</strong>
                                  </v-col>
                                </v-row>
                                <template v-slot:actions>
                                  <v-icon color="#B61C1C">
                                    mdi-chevron-down-circle
                                  </v-icon>
                                </template>
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <v-row>
                                  <v-col cols="12" sm="12">
                                    <v-row v-if="dataInfo.appImageUrl">
                                      <v-col class="text-center">
                                        <v-avatar size="150px" v-ripple class="mb-3">
                                          <img :src="dataInfo.appImageUrl" alt="avatar">
                                        </v-avatar>
                                      </v-col>
                                    </v-row>
                                    <v-row>
                                      <v-col cols="12" sm="12">
                                        <v-row>
                                          <v-col cols="10" sm="2">
                                              <p id="Color-Font-Preview"><strong> ชื่อ นามสกุล </strong></p>
                                          </v-col>
                                          <v-col cols="2" sm="1">
                                              <p id="Color-Font-Preview"><strong> : </strong></p>
                                          </v-col>
                                          <v-col cols="12" sm="3">
                                              <p id="Color-Font"> {{ dataInfo.appTitle_NameTH+dataInfo.appFirst_NameTH+' '+dataInfo.appLast_NameTH }} </p>
                                          </v-col>
                                          <v-col cols="10" sm="2">
                                              <p id="Color-Font-Preview"><strong> Full Name </strong></p>
                                          </v-col>
                                          <v-col cols="2" sm="1">
                                              <p id="Color-Font-Preview"><strong> : </strong></p>
                                          </v-col>
                                          <v-col cols="12" sm="3">
                                              <p id="Color-Font"> {{ dataInfo.appTitle_NameEN+' '+dataInfo.appFirst_NameEN+' '+dataInfo.appLast_NameEN }} </p>
                                          </v-col>
                                        </v-row>
                                        <v-row>
                                          <v-col cols="10" sm="2">
                                              <p id="Color-Font-Preview"><strong> เพศ </strong></p>
                                          </v-col>
                                          <v-col cols="2" sm="1">
                                              <p id="Color-Font-Preview"><strong> : </strong></p>
                                          </v-col>
                                          <v-col cols="12" sm="3">
                                              <p id="Color-Font"> {{ dataInfo.appGender }} </p>
                                          </v-col>
                                          <v-col cols="10" sm="2">
                                              <p id="Color-Font-Preview"><strong> วันเดือนปีเกิด </strong></p>
                                          </v-col>
                                          <v-col cols="2" sm="1">
                                              <p id="Color-Font-Preview"><strong> : </strong></p>
                                          </v-col>
                                          <v-col cols="12" sm="3">
                                              <p id="Color-Font"> {{ dataInfo.appBirthday | dateBirthday }} </p>
                                          </v-col>
                                        </v-row>
                                        <v-row>
                                          <v-col cols="10" sm="2">
                                              <p id="Color-Font-Preview"><strong> เลขบัตรประชาชน </strong></p>
                                          </v-col>
                                          <v-col cols="2" sm="1">
                                              <p id="Color-Font-Preview"><strong> : </strong></p>
                                          </v-col>
                                          <v-col cols="12" sm="3">
                                              <p id="Color-Font"> {{ dataInfo.appIDCard }} </p>
                                          </v-col>
                                          <v-col cols="10" sm="2">
                                              <p id="Color-Font-Preview"><strong> สถานภาพสมรส </strong></p>
                                          </v-col>
                                          <v-col cols="2" sm="1">
                                              <p id="Color-Font-Preview"><strong> : </strong></p>
                                          </v-col>
                                          <v-col cols="12" sm="3">
                                              <p id="Color-Font"> {{ dataInfo.masMaritalStatusCode }} </p>
                                          </v-col>
                                        </v-row>
                                        <v-row>
                                          <v-col cols="10" sm="2">
                                              <p id="Color-Font-Preview"><strong> เบอร์โทรศัพท์ </strong></p>
                                          </v-col>
                                          <v-col cols="2" sm="1">
                                              <p id="Color-Font-Preview"><strong> : </strong></p>
                                          </v-col>
                                          <v-col cols="12" sm="3">
                                              <p id="Color-Font"> {{ dataInfo.appTel }} </p>
                                          </v-col>
                                          <v-col cols="10" sm="2">
                                              <p id="Color-Font-Preview"><strong> E-mail </strong></p>
                                          </v-col>
                                          <v-col cols="2" sm="1">
                                              <p id="Color-Font-Preview"><strong> : </strong></p>
                                          </v-col>
                                          <v-col cols="12" sm="3">
                                              <p id="Color-Font"> {{ dataInfo.appEmail }} </p>
                                          </v-col>
                                        </v-row>
                                        <v-row>
                                          <v-col cols="12" sm="12">
                                              <hr class="Divider">
                                          </v-col>
                                        </v-row>
                                        <v-row>
                                          <v-col cols="10" sm="2">
                                              <p id="Color-Font-Preview"><strong> เงินเดือนที่ต้องการ </strong></p>
                                          </v-col>
                                          <v-col cols="2" sm="1">
                                              <p id="Color-Font-Preview"><strong> : </strong></p>
                                          </v-col>
                                          <v-col cols="12" sm="3">
                                              <p id="Color-Font"> {{ dataInfo.appExpectedSalary }} </p>
                                          </v-col>
                                          <v-col cols="10" sm="2">
                                              <p id="Color-Font-Preview"><strong> ช่องทางข่าวสาร </strong></p>
                                          </v-col>
                                          <v-col cols="2" sm="1">
                                              <p id="Color-Font-Preview"><strong> : </strong></p>
                                          </v-col>
                                          <v-col cols="12" sm="3">
                                              <p id="Color-Font"> {{ dataInfo.appChannal }} </p>
                                          </v-col>
                                        </v-row>
                                        <div style="margin-top: 15px" v-if="dataInfo.appChannal == 'บุคคลภายในแนะนำ'">
                                          <v-row>
                                              <v-col cols="10" sm="2">
                                                  <p id="Color-Font-Preview"><strong> ผู้แนะนำ </strong></p>
                                              </v-col>
                                              <v-col cols="2" sm="1">
                                                  <p id="Color-Font-Preview"><strong> : </strong></p>
                                              </v-col>
                                              <v-col cols="12" sm="3">
                                                  <p id="Color-Font"> {{ dataInfo.appTitle_NameSuggester+dataInfo.appFirst_NameSuggester+' '+dataInfo.appLast_NameSuggester }} </p>
                                              </v-col>
                                              <v-col cols="10" sm="2">
                                                  <p id="Color-Font-Preview"><strong> ตำแหน่ง </strong></p>
                                              </v-col>
                                              <v-col cols="2" sm="1">
                                                  <p id="Color-Font-Preview"><strong> : </strong></p>
                                              </v-col>
                                              <v-col cols="12" sm="3">
                                                  <p id="Color-Font"> {{ dataInfo.appSuggesterPosition }} </p>
                                              </v-col>
                                              <v-col cols="10" sm="2">
                                                  <p id="Color-Font-Preview"><strong> ความสัมพันธ์ </strong></p>
                                              </v-col>
                                              <v-col cols="2" sm="1">
                                                  <p id="Color-Font-Preview"><strong> : </strong></p>
                                              </v-col>
                                              <v-col cols="12" sm="3">
                                                  <p id="Color-Font"> {{ dataInfo.appSuggesterStatus }} </p>
                                              </v-col>
                                          </v-row>
                                        </div>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-expansion-panel-content>
                            </v-expansion-panel>

                            <!-- ที่อยู่อาศัย -->
                            <v-expansion-panel>
                              <v-expansion-panel-header>
                                <v-row no-gutters>
                                  <v-col cols="12">
                                    <v-icon left color="#808588"> mdi-home </v-icon>
                                    <strong class="Color-Font"> ที่อยู่อาศัย</strong>
                                  </v-col>
                                </v-row>
                                <template v-slot:actions>
                                  <v-icon color="#B61C1C">
                                    mdi-chevron-down-circle
                                  </v-icon>
                                </template>
                              </v-expansion-panel-header>
                              <v-expansion-panel-content v-if="dataAddress != 0">
                                <v-row>
                                  <v-col cols="12" sm="12" v-for="(items, index) in dataAddress" :key="index">
                                    <v-row>
                                      <v-col cols="12" sm="12">
                                        <v-card>
                                          <v-card-title>
                                            <v-row>
                                              <v-col cols="12" sm="12">
                                                <span id="Color-Font-Preview"><strong> {{ items.appAddressStatus }} </strong></span>
                                                <span v-if="items.appAddessStatusMessenger == 'True'"> (ที่อยู่จัดส่งไปรษณีย์) </span>
                                              </v-col>
                                              <v-col cols="12" sm="12">
                                                <hr class="Divider">
                                              </v-col>
                                            </v-row>
                                          </v-card-title>
                                          <v-card-text>
                                            <v-row>
                                              <v-col cols="10" sm="2">
                                                  <p id="Color-Font-Preview"><strong> ประเภทที่พัก </strong></p>
                                              </v-col>
                                              <v-col cols="2" sm="1">
                                                  <p id="Color-Font-Preview"><strong> : </strong></p>
                                              </v-col>
                                              <v-col cols="12" sm="3">
                                                  <p id="Color-Font"> {{ items.appAddressType }} </p>
                                              </v-col>
                                              <v-col cols="10" sm="2">
                                                  <p id="Color-Font-Preview"><strong> บ้านเลขที่ </strong></p>
                                              </v-col>
                                              <v-col cols="2" sm="1">
                                                  <p id="Color-Font-Preview"><strong> : </strong></p>
                                              </v-col>
                                              <v-col cols="12" sm="3">
                                                  <p id="Color-Font"> {{ items.appAddressName }} </p>
                                              </v-col>
                                            </v-row>
                                            <v-row>
                                              <v-col cols="10" sm="2">
                                                  <p id="Color-Font-Preview"><strong> ตำบล </strong></p>
                                              </v-col>
                                              <v-col cols="2" sm="1">
                                                  <p id="Color-Font-Preview"><strong> : </strong></p>
                                              </v-col>
                                              <v-col cols="12" sm="3">
                                                  <p id="Color-Font"> {{ items.appAddressSubDistrict }} </p>
                                              </v-col>
                                              <v-col cols="10" sm="2">
                                                  <p id="Color-Font-Preview"><strong> อำเภอ </strong></p>
                                              </v-col>
                                              <v-col cols="2" sm="1">
                                                  <p id="Color-Font-Preview"><strong> : </strong></p>
                                              </v-col>
                                              <v-col cols="12" sm="3">
                                                  <p id="Color-Font"> {{ items.appAddressDistrict }} </p>
                                              </v-col>
                                            </v-row>
                                            <v-row>
                                              <v-col cols="10" sm="2">
                                                  <p id="Color-Font-Preview"><strong> จังหวัด </strong></p>
                                              </v-col>
                                              <v-col cols="2" sm="1">
                                                  <p id="Color-Font-Preview"><strong> : </strong></p>
                                              </v-col>
                                              <v-col cols="12" sm="3">
                                                  <p id="Color-Font"> {{ items.appAddressProvine }} </p>
                                              </v-col>
                                              <v-col cols="10" sm="2">
                                                  <p id="Color-Font-Preview"><strong> รหัสไปรษณีย์ </strong></p>
                                              </v-col>
                                              <v-col cols="2" sm="1">
                                                  <p id="Color-Font-Preview"><strong> : </strong></p>
                                              </v-col>
                                              <v-col cols="12" sm="3">
                                                  <p id="Color-Font"> {{ items.appAddressZipcode }} </p>
                                              </v-col>
                                            </v-row>
                                          </v-card-text>
                                        </v-card>
                                      </v-col>
                                      <br />
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-expansion-panel-content>
                            </v-expansion-panel>

                            <!-- ประวัติครอบครัว -->
                            <v-expansion-panel>
                              <v-expansion-panel-header>
                                <v-row no-gutters>
                                  <v-col cols="12">
                                    <v-icon left color="#808588"> mdi-mother-nurse </v-icon>
                                    <strong class="Color-Font"> ประวัติครอบครัว </strong>
                                  </v-col>
                                </v-row>
                                <template v-slot:actions>
                                  <v-icon color="#B61C1C">
                                    mdi-chevron-down-circle
                                  </v-icon>
                                </template>
                              </v-expansion-panel-header>
                              <v-expansion-panel-content v-if="dataFamily != 0">
                                <v-row>
                                  <v-col cols="12" sm="12" v-for="(items, index) in dataFamily" :key="index">
                                    <v-row>
                                        <v-col cols="12" sm="12">
                                            <v-card elevation="2">
                                                <v-card-title>
                                                    <v-row>
                                                        <v-col cols="12" sm="12">
                                                            <span id="Color-Font-Preview"><strong> {{ items.familyStatus }} </strong></span>
                                                            <span v-if="items.emergencyStatus == 'True'"> (ผู้ติดต่อฉุกเฉิน) </span>
                                                        </v-col>
                                                        <v-col cols="12" sm="12">
                                                            <hr class="Divider">
                                                        </v-col>
                                                    </v-row>
                                                </v-card-title>
                                                <v-card-text>
                                                    <v-row>
                                                        <v-col cols="10" sm="2">
                                                            <p id="Color-Font-Preview"><strong> ชื่อ-นามสกุล </strong></p>
                                                        </v-col>
                                                        <v-col cols="2" sm="1">
                                                            <p id="Color-Font-Preview"><strong> : </strong></p>
                                                        </v-col>
                                                        <v-col cols="12" sm="3">
                                                            <p id="Color-Font"> {{ items.familyTitleName+items.familyFirstName+' '+items.familyLastName }} </p>
                                                        </v-col>
                                                        <v-col cols="10" sm="2">
                                                            <p id="Color-Font-Preview"><strong> เบอร์โทรศัพท์ </strong></p>
                                                        </v-col>
                                                        <v-col cols="2" sm="1">
                                                            <p id="Color-Font-Preview"><strong> : </strong></p>
                                                        </v-col>
                                                        <v-col cols="12" sm="3">
                                                            <p id="Color-Font"> {{ items.familyTel }} </p>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="10" sm="2">
                                                            <p id="Color-Font-Preview"><strong> อาชีพ </strong></p>
                                                        </v-col>
                                                        <v-col cols="2" sm="1">
                                                            <p id="Color-Font-Preview"><strong> : </strong></p>
                                                        </v-col>
                                                        <v-col cols="12" sm="3">
                                                            <p id="Color-Font"> {{ items.familyCareer }} </p>
                                                        </v-col>
                                                        <v-col cols="10" sm="2">
                                                            <p id="Color-Font-Preview"><strong> ที่อยู่/ที่ทำงาน </strong></p>
                                                        </v-col>
                                                        <v-col cols="2" sm="1">
                                                            <p id="Color-Font-Preview"><strong> : </strong></p>
                                                        </v-col>
                                                        <v-col cols="12" sm="3">
                                                            <p id="Color-Font"> {{ items.familyAddress }} </p>
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                            <br />
                                        </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-expansion-panel-content>
                            </v-expansion-panel>

                            <!-- ประวัติการศึกษา -->
                            <v-expansion-panel>
                              <v-expansion-panel-header>
                                <v-row no-gutters>
                                  <v-col cols="12">
                                    <v-icon left color="#808588"> mdi-school </v-icon>
                                    <strong class="Color-Font"> ประวัติการศึกษา </strong>
                                  </v-col>
                                </v-row>
                                <template v-slot:actions>
                                  <v-icon color="#B61C1C">
                                    mdi-chevron-down-circle
                                  </v-icon>
                                </template>
                              </v-expansion-panel-header>
                              <v-expansion-panel-content v-if="dataEducation != 0">
                                <v-row>
                                  <v-col cols="12" sm="12" v-for="(items, index) in dataEducation" :key="index">
                                    <v-row>
                                        <v-col cols="12" sm="12">
                                            <v-card elevation="2">
                                                <v-card-title>
                                                    <v-row>
                                                        <v-col cols="12" sm="10">
                                                            <h5 id="Color-Font-Preview"><strong> {{ items.educationName }} </strong></h5>
                                                        </v-col>
                                                        <v-col cols="12" sm="2">
                                                            <h5 id="Color-Font-Preview"><strong> ปีที่จบ {{ items.educationYear }} </strong></h5>
                                                        </v-col>
                                                        <v-col cols="12" sm="12">
                                                            <hr class="Divider">
                                                        </v-col>
                                                    </v-row>
                                                </v-card-title>
                                                <v-card-text>
                                                    <v-row>
                                                        <v-col cols="10" sm="2">
                                                            <p id="Color-Font-Preview"><strong> ระดับการศึกษา </strong></p>
                                                        </v-col>
                                                        <v-col cols="2" sm="1">
                                                            <p id="Color-Font-Preview"><strong> : </strong></p>
                                                        </v-col>
                                                        <v-col cols="12" sm="3">
                                                            <p id="Color-Font"> {{ items.educationLevel }} </p>
                                                        </v-col>
                                                        <v-col cols="10" sm="2">
                                                            <p id="Color-Font-Preview"><strong> กลุ่มสถาบันการศึกษา </strong></p>
                                                        </v-col>
                                                        <v-col cols="2" sm="1">
                                                            <p id="Color-Font-Preview"><strong> : </strong></p>
                                                        </v-col>
                                                        <v-col cols="12" sm="3">
                                                            <p id="Color-Font"> {{ items.educationAcademyGroup }} </p>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="10" sm="2">
                                                            <p id="Color-Font-Preview"><strong> คณะ </strong></p>
                                                        </v-col>
                                                        <v-col cols="2" sm="1">
                                                            <p id="Color-Font-Preview"><strong> : </strong></p>
                                                        </v-col>
                                                        <v-col cols="12" sm="3">
                                                            <p id="Color-Font"> {{ items.educationFaculty }} </p>
                                                        </v-col>
                                                        <v-col cols="10" sm="2">
                                                            <p id="Color-Font-Preview"><strong> สาขาวิชา </strong></p>
                                                        </v-col>
                                                        <v-col cols="2" sm="1">
                                                            <p id="Color-Font-Preview"><strong> : </strong></p>
                                                        </v-col>
                                                        <v-col cols="12" sm="3">
                                                            <p id="Color-Font"> {{ items.educationDepartment }} </p>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="10" sm="2">
                                                            <p id="Color-Font-Preview"><strong> เกรดเฉลี่ย </strong></p>
                                                        </v-col>
                                                        <v-col cols="2" sm="1">
                                                            <p id="Color-Font-Preview"><strong> : </strong></p>
                                                        </v-col>
                                                        <v-col cols="12" sm="3">
                                                            <p id="Color-Font"> {{ items.educationGrade }} </p>
                                                        </v-col>
                                                        <v-col cols="10" sm="2">
                                                            <p id="Color-Font-Preview"><strong> สถานะการศึกษา </strong></p>
                                                        </v-col>
                                                        <v-col cols="2" sm="1">
                                                            <p id="Color-Font-Preview"><strong> : </strong></p>
                                                        </v-col>
                                                        <v-col cols="12" sm="3">
                                                            <p id="Color-Font"> {{ items.educationStatus }} </p>
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                            <br />
                                        </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-expansion-panel-content>
                            </v-expansion-panel>

                            <!-- ประสบการณ์ทำงาน -->
                            <v-expansion-panel>
                              <v-expansion-panel-header>
                                <v-row no-gutters>
                                  <v-col cols="12">
                                    <v-icon left color="#808588"> mdi-briefcase-variant </v-icon>
                                    <strong class="Color-Font"> ประสบการณ์ทำงาน </strong>
                                  </v-col>
                                </v-row>
                                <template v-slot:actions>
                                  <v-icon color="#B61C1C">
                                    mdi-chevron-down-circle
                                  </v-icon>
                                </template>
                              </v-expansion-panel-header>
                              <v-expansion-panel-content v-if="dataExperince != 0">
                                <v-row>
                                  <v-col cols="12" sm="12" v-for="(items, index) in dataExperince" :key="index">
                                    <v-row>
                                        <v-col cols="12" sm="12">
                                            <v-card elevation="2">
                                                <v-card-title>
                                                    <v-row>
                                                        <v-col cols="12" sm="12">
                                                            <h5 id="Color-Font-Preview"><strong> {{ items.lastWorkExpName }} </strong></h5>
                                                        </v-col>
                                                        <v-col cols="12" sm="2">
                                                            <h6 id="Color-Font-Preview"> {{ items.workExpAddress }} </h6>
                                                        </v-col>
                                                        <v-col cols="12" sm="12">
                                                            <hr class="Divider">
                                                        </v-col>
                                                    </v-row>
                                                </v-card-title>
                                                <v-card-text>
                                                    <v-row>
                                                        <v-col cols="10" sm="2">
                                                            <p id="Color-Font-Preview"><strong> ตั้งแต่วันที่ </strong></p>
                                                        </v-col>
                                                        <v-col cols="2" sm="1">
                                                            <p id="Color-Font-Preview"><strong> : </strong></p>
                                                        </v-col>
                                                        <v-col cols="12" sm="3">
                                                            <p id="Color-Font"> {{ items.startDate | dateStart }} </p>
                                                        </v-col>
                                                        <v-col cols="10" sm="2">
                                                            <p id="Color-Font-Preview"><strong> สิ้นสุดวันที่ </strong></p>
                                                        </v-col>
                                                        <v-col cols="2" sm="1">
                                                            <p id="Color-Font-Preview"><strong> : </strong></p>
                                                        </v-col>
                                                        <v-col cols="12" sm="3">
                                                            <p id="Color-Font"> {{ items.endDate | dateEnd }} </p>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="10" sm="2">
                                                            <p id="Color-Font-Preview"><strong> ตำแหน่ง </strong></p>
                                                        </v-col>
                                                        <v-col cols="2" sm="1">
                                                            <p id="Color-Font-Preview"><strong> : </strong></p>
                                                        </v-col>
                                                        <v-col cols="12" sm="3">
                                                            <p id="Color-Font"> {{ items.lastPosition }} </p>
                                                        </v-col>
                                                        <v-col cols="10" sm="2">
                                                            <p id="Color-Font-Preview"><strong> เงินเดือนที่ได้รับ </strong></p>
                                                        </v-col>
                                                        <v-col cols="2" sm="1">
                                                            <p id="Color-Font-Preview"><strong> : </strong></p>
                                                        </v-col>
                                                        <v-col cols="12" sm="3">
                                                            <p id="Color-Font"> {{ items.lastSalary }} </p>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="10" sm="2">
                                                            <p id="Color-Font-Preview"><strong> คำอธิบายลักษณะงาน </strong></p>
                                                        </v-col>
                                                        <v-col cols="2" sm="1">
                                                            <p id="Color-Font-Preview"><strong> : </strong></p>
                                                        </v-col>
                                                        <v-col cols="12" sm="9">
                                                            <p id="Color-Font"> {{ items.jobDescription }} </p>
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                            <br />
                                        </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-expansion-panel-content>
                            </v-expansion-panel>

                            <!-- ความสามารถพิเศษและงานอดิเรก -->
                            <v-expansion-panel>
                              <v-expansion-panel-header>
                                <v-row no-gutters>
                                  <v-col cols="12">
                                    <v-icon left color="#808588"> mdi-puzzle-star </v-icon>
                                    <strong class="Color-Font"> ความสามารถพิเศษและงานอดิเรก </strong>
                                  </v-col>
                                </v-row>
                                <template v-slot:actions>
                                  <v-icon color="#B61C1C">
                                    mdi-chevron-down-circle
                                  </v-icon>
                                </template>
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <v-row>
                                  <v-col>
                                    <v-row v-if="dataLanguage != 0">
                                      <v-col cols="12" sm="12">
                                        <v-card elevation="2">
                                          <v-card-title>
                                            <v-row>
                                              <v-col cols="12" sm="12">
                                                ทักษะภาษา
                                              </v-col>
                                              <v-col cols="12" sm="12">
                                                <hr class="Divider">
                                              </v-col>
                                            </v-row>
                                          </v-card-title>
                                          <v-card-text>
                                            <v-row>
                                              <v-col>
                                                <v-row>
                                                  <v-col>
                                                    <p id="Color-Font-Preview"><strong> ภาษา </strong></p>
                                                  </v-col>
                                                  <v-col>
                                                    <p id="Color-Font-Preview"><strong> การอ่าน </strong></p>
                                                  </v-col>
                                                  <v-col>
                                                    <p id="Color-Font-Preview"><strong> การพูด </strong></p>
                                                  </v-col>
                                                  <v-col>
                                                    <p id="Color-Font-Preview"><strong> การเขียน </strong></p>
                                                  </v-col>
                                                </v-row>
                                              </v-col>
                                            </v-row>
                                            <v-row>
                                              <v-col cols="12" sm="12" v-for="(items, index) in dataLanguage" :key="index">
                                                <v-row>
                                                  <v-col>
                                                    <p id="Color-Font"> {{ items.languageCode }} </p>
                                                  </v-col>
                                                  <v-col>
                                                    <p id="Color-Font"> {{ items.appLanguageRead }} </p>
                                                  </v-col>
                                                  <v-col>
                                                    <p id="Color-Font"> {{ items.appLanguageSpeak }} </p>
                                                  </v-col>
                                                  <v-col>
                                                    <p id="Color-Font"> {{ items.appLanguageWrite }} </p>
                                                  </v-col>
                                                </v-row>
                                              </v-col>
                                            </v-row>
                                          </v-card-text>
                                        </v-card>
                                        <br />
                                      </v-col>
                                    </v-row>
                                    <v-row v-if="dataComSkill != 0">
                                      <v-col cols="12" sm="12">
                                        <v-card elevation="2">
                                          <v-card-title>
                                            <v-row>
                                              <v-col cols="12" sm="12">
                                                ทักษะคอมพิวเตอร์
                                              </v-col>
                                              <v-col cols="12" sm="12">
                                                <hr class="Divider">
                                              </v-col>
                                            </v-row>
                                          </v-card-title>
                                          <v-card-text>
                                            <v-row>
                                              <v-col>
                                                <v-row>
                                                  <v-col cols="8" sm="8">
                                                    <p id="Color-Font-Preview"><strong> ทักษะ </strong></p>
                                                  </v-col>
                                                  <v-col cols="4" sm="4" class="text-center">
                                                    <p id="Color-Font-Preview"><strong> ระดับ </strong></p>
                                                  </v-col>
                                                </v-row>
                                              </v-col>
                                            </v-row>
                                            <v-row>
                                              <v-col cols="12" sm="12" v-for="(items, index) in dataComSkill" :key="index">
                                                <v-row>
                                                  <v-col cols="8" sm="8">
                                                    <p id="Color-Font"> {{ items.masComputerSkillCode }} </p>
                                                  </v-col>
                                                  <v-col cols="4" sm="4" class="text-center">
                                                    <p id="Color-Font"> {{ items.appComputerSkillScore }} </p>
                                                  </v-col>
                                                </v-row>
                                              </v-col>
                                            </v-row>
                                          </v-card-text>
                                        </v-card>
                                        <br />
                                      </v-col>
                                    </v-row>
                                    <v-row v-if="dataCertificate != 0">
                                      <v-col cols="12" sm="12">
                                        <v-card elevation="2">
                                          <v-card-title>
                                            <v-row>
                                              <v-col cols="12" sm="12">
                                                ประกาศนียบัตร
                                              </v-col>
                                              <v-col cols="12" sm="12">
                                                <hr class="Divider">
                                              </v-col>
                                            </v-row>
                                          </v-card-title>
                                          <v-card-text>
                                            <v-row>
                                              <v-col cols="12" sm="12" v-for="(items, index) in dataCertificate" :key="index">
                                                <v-row>
                                                  <v-col cols="10" sm="3">
                                                      <p id="Color-Font-Preview"><strong> ประกาศนียบัตร / คุณวุฒิพิเศษ </strong></p>
                                                  </v-col>
                                                  <v-col cols="2" sm="1">
                                                      <p id="Color-Font-Preview"><strong> : </strong></p>
                                                  </v-col>
                                                  <v-col cols="12" sm="8">
                                                      <p id="Color-Font"> {{ items.cerName }} </p>
                                                  </v-col>
                                                </v-row>
                                                <v-row>
                                                  <v-col cols="10" sm="3">
                                                      <p id="Color-Font-Preview"><strong> สถาบัน </strong></p>
                                                  </v-col>
                                                  <v-col cols="2" sm="1">
                                                      <p id="Color-Font-Preview"><strong> : </strong></p>
                                                  </v-col>
                                                  <v-col cols="12" sm="8">
                                                      <p id="Color-Font"> {{ items.cerAddress }} </p>
                                                  </v-col>
                                                </v-row>
                                                <v-row>
                                                  <v-col cols="10" sm="3">
                                                      <p id="Color-Font-Preview"><strong> วันที่อบรม </strong></p>
                                                  </v-col>
                                                  <v-col cols="2" sm="1">
                                                      <p id="Color-Font-Preview"><strong> : </strong></p>
                                                  </v-col>
                                                  <v-col cols="12" sm="8">
                                                      <p id="Color-Font"> {{ items.cerDateFrom | dateCer }} </p>
                                                  </v-col>
                                                </v-row>
                                                <v-divider></v-divider>
                                              </v-col>
                                            </v-row>
                                          </v-card-text>
                                        </v-card>
                                        <br />
                                      </v-col>
                                    </v-row>
                                    <v-row>
                                      <v-col cols="12" sm="12">
                                        <v-card elevation="2">
                                          <v-card-title>
                                            <v-row>
                                              <v-col cols="12" sm="12">
                                                ความสามารถทางอาชีพ
                                              </v-col>
                                              <v-col cols="12" sm="12">
                                                <hr class="Divider">
                                              </v-col>
                                            </v-row>
                                          </v-card-title>
                                          <v-card-text>
                                            <v-row>
                                              <v-col>
                                                <v-row>
                                                  <v-col cols="10" sm="3">
                                                      <p id="Color-Font-Preview"><strong> ความสามารถทางอาชีพ </strong></p>
                                                  </v-col>
                                                  <v-col cols="2" sm="1">
                                                      <p id="Color-Font-Preview"><strong> : </strong></p>
                                                  </v-col>
                                                  <v-col cols="12" sm="8">
                                                      <p id="Color-Font"> {{ dataInfo.appGenius }} </p>
                                                  </v-col>
                                                </v-row>
                                              </v-col>
                                            </v-row>
                                          </v-card-text>
                                        </v-card>
                                        <br />
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </v-col>
                      </v-row>
                      <v-row class="text-right">
                        <v-col>
                          <v-btn
                            v-if="AppInfo.applyStatus != 'Approve'"
                            color="#B61C1C"
                            dark
                            @click="ApproveData(AppInfo.applyId, AppInfo, dataInfo, dataAddress, dataFamily, dataEducation, dataExperince, dataCertificate, dataLanguage, dataComSkill)"
                          >
                            โอนย้ายข้อมูล
                          </v-btn>
                        </v-col>
                      </v-row>
                    </div>
                  </v-list>
                </v-card>
              </v-dialog>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile,
    moment
  },
  created () {
    setInterval(this.getNowGlobal, 1000)
  },
  filters: {
    dateBirthday: function (value) {
      return moment(value).locale('th').add(543, 'year').format('LL')
      // The date format here can be customized
    },
    dateStart: function (value) {
      return moment(value).locale('th').add(543, 'year').format('LL')
      // The date format here can be customized
    },
    dateEnd: function (value) {
      return moment(value).locale('th').add(543, 'year').format('LL')
      // The date format here can be customized
    },
    dateCer: function (value) {
      return moment(value).locale('th').add(543, 'year').format('LL')
      // The date format here can be customized
    }
  },
  data () {
    return {
      PK: '',
      path: '/application_apply/', // Path Model
      session: this.$session.getAll(),
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'ผู้สมัคร',
          disabled: false,
          href: '/HRM/Application/Applicant'
        }
      ],
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      number: 0,
      dialog: false,
      panel: [0],
      // Data Table Config
      columns: [
        { text: 'รหัสผู้สมัคร', value: 'applyCode' },
        { text: 'ชื่อผู้สมัคร', value: 'appFirst_NameTH' },
        { text: 'นามสกุล', value: 'appLast_NameTH' },
        { text: 'ตำแหน่ง', value: 'positionName' },
        { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
        { text: 'วันที่อัพเดท', value: 'LAST_DATE' },
        { text: 'Action', value: 'action', sortable: false, align: 'center' }
      ],
      dataItem: [],
      dataPosition: [],
      // End Data Table Config
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      // End Export Config
      AppInfo: [0],
      dataInfo: [],
      dataAddress: [],
      dataFamily: [],
      dataEducation: [],
      dataExperince: [],
      dataCertificate: [],
      dataLanguage: [],
      dataComSkill: [],
      dataInfoEx: [],
      dataAddressEx: [],
      dataFamilyEx: [],
      dataEducationEx: [],
      dataExperinceEx: [],
      dataCertificateEx: [],
      dataLanguageEx: [],
      dataComSkillEx: [],
      formUpdate: {
        applyStatus: 'Approve'
      }
    }
  },
  async mounted () {
    this.getGetToken(this.DNS_IP)
    this.dataReady = false
    // Get Data
    // this.getDataGlobal(this.DNS_IP, this.path)
    await this.showDataAll()
    await this.getDataPosition()
    await this.reloadDataById()
  },
  methods: {
    async reloadDataById () {
      await this.getDataByInfoAll()
      await this.getDataByAddressAll()
      await this.getDataByFamilyAll()
      await this.getDataByEducationAll()
      await this.getDataByExperinceAll()
      await this.getDataByCertificateAll()
      await this.getDataByLanguageAll()
      await this.getDataByComSkillAll()
    },
    exportToExcelAll () {
      // On Click Excel download button

      // export json to Worksheet of Excel
      // only array possible
      var InfoWS = XLSX.utils.json_to_sheet(this.dataInfoEx)
      var AddressWS = XLSX.utils.json_to_sheet(this.dataAddressEx)
      var FamilyWS = XLSX.utils.json_to_sheet(this.dataFamilyEx)
      var EducationWS = XLSX.utils.json_to_sheet(this.dataEducationEx)
      var ExperinceWS = XLSX.utils.json_to_sheet(this.dataExperinceEx)
      var CertificateWS = XLSX.utils.json_to_sheet(this.dataCertificateEx)
      var LanguageWS = XLSX.utils.json_to_sheet(this.dataLanguageEx)
      var ComSkillWS = XLSX.utils.json_to_sheet(this.dataComSkillEx)

      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, InfoWS, 'ข้อมูลส่วนตัว') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, AddressWS, 'ที่อยู่อาศัย')
      XLSX.utils.book_append_sheet(wb, FamilyWS, 'ครอบครัว')
      XLSX.utils.book_append_sheet(wb, EducationWS, 'การศึกษา')
      XLSX.utils.book_append_sheet(wb, ExperinceWS, 'ประสบการณ์ทำงาน')
      XLSX.utils.book_append_sheet(wb, CertificateWS, 'ประกาศนียบัตร')
      XLSX.utils.book_append_sheet(wb, LanguageWS, 'ภาษา')
      XLSX.utils.book_append_sheet(wb, ComSkillWS, 'คอมพิวเตอร์')

      // export Excel file
      XLSX.writeFile(wb, 'รายชื่อผู้สมัครงาน.xlsx') // name of the file is 'book.xlsx'
    },
    async exportToExcel () {
      // On Click Excel download button
      // export json to Worksheet of Excel
      // only array possible
      var InfoWS = XLSX.utils.json_to_sheet(this.dataInfo)
      var AddressWS = XLSX.utils.json_to_sheet(this.dataAddress)
      var FamilyWS = XLSX.utils.json_to_sheet(this.dataFamily)
      var EducationWS = XLSX.utils.json_to_sheet(this.dataEducation)
      var ExperinceWS = XLSX.utils.json_to_sheet(this.dataExperince)
      var CertificateWS = XLSX.utils.json_to_sheet(this.dataCertificate)
      var LanguageWS = XLSX.utils.json_to_sheet(this.dataLanguage)
      var ComSkillWS = XLSX.utils.json_to_sheet(this.dataComSkill)

      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, InfoWS, 'ข้อมูลส่วนตัว') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, AddressWS, 'ที่อยู่อาศัย')
      XLSX.utils.book_append_sheet(wb, FamilyWS, 'ครอบครัว')
      XLSX.utils.book_append_sheet(wb, EducationWS, 'การศึกษา')
      XLSX.utils.book_append_sheet(wb, ExperinceWS, 'ประสบการณ์ทำงาน')
      XLSX.utils.book_append_sheet(wb, CertificateWS, 'ประกาศนียบัตร')
      XLSX.utils.book_append_sheet(wb, LanguageWS, 'ภาษา')
      XLSX.utils.book_append_sheet(wb, ComSkillWS, 'คอมพิวเตอร์')

      // export Excel file
      XLSX.writeFile(wb, 'รายบุคคล.xlsx') // name of the file is 'book.xlsx'
    },
    async showDataAll () {
      this.dataReady = false
      this.dataItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/application_apply/' + 'get?applyStatus=Unapprove',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItem = response.data
          this.number = this.dataItem.length
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
        })
    },
    async getDataPosition () {
      this.dataReady = false
      this.dataPosition = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/application_link_position/' + 'get',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataPosition = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
        })
    },
    async showDataByPosition (position) {
      this.dataReady = false
      this.dataItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/application_apply/' + "get?positionName=" + position + '&applyStatus=Unapprove',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItem = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
        })
    },
    async ApproveData (id, AppInfo, dataInfo, dataAddress, dataFamily, dataEducation, dataExperince, dataCertificate, dataLanguage, dataComSkill) {
      console.log(AppInfo)
      console.log(dataInfo)
      console.log(this.formUpdate)
      this.$swal({
        title: 'ข้อมูลผู้สมัครนี้จะถูกโอนย้ายไปยังพนักงานทดลองงาน คุณต้องการยืนยันใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          let id = this.AppInfo.applyId
          let dt = this.formUpdate
          this.dataReady = false
          let ds = {
            applyStatus: dt.applyStatus,
            LAST_USER: this.$session.getAll().data.userName
          }
          console.log('id', id)
          console.log('ds', ds)
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + '/application_apply/' + "edit/" + id,
              ds,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              this.$swal('เรียบร้อย', 'อนุมัติข้อมูลเรียบร้อย', 'success')
              this.dialog = false
              await this.showDataAll()
              await this.MoveTBL(AppInfo, dataInfo, dataAddress, dataFamily, dataEducation, dataExperince, dataCertificate, dataLanguage, dataComSkill)
            })
          // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log(error)
        })
    },
    async MoveTBL (AppInfo, dataInfo, dataAddress, dataFamily, dataEducation, dataExperince, dataCertificate, dataLanguage, dataComSkill) {
      await this.getRunningCodeGlobal(this.DNS_IP, 'EMP').then(
        async (response) => {
          let dtInfo = {
            empCode: response,
            positionCode: AppInfo.positionCode,
            empTitle_NameTH: dataInfo.appTitle_NameTH,
            empFirst_NameTH: dataInfo.appFirst_NameTH,
            empLast_NameTH: dataInfo.appLast_NameTH,
            empTitle_NameEN: dataInfo.appTitle_NameEN,
            empFirst_NameEN: dataInfo.appFirst_NameEN,
            empLast_NameEN: dataInfo.appLast_NameEN,
            empNickname: dataInfo.appNickname,
            empBirthday: dataInfo.appBirthday,
            empGender: dataInfo.appGender,
            empIDCard: dataInfo.appIDCard,
            empEmail: dataInfo.appEmail,
            empTel: dataInfo.appTel,
            empEmergencyCall: dataInfo.appEmergencyCall,
            empFacebook: dataInfo.appFacebook,
            empLineID: dataInfo.appLineID,
            empDriverLicense: dataInfo.appDriverLicense,
            empDriverLicenseType: dataInfo.appDriverLicenseType,
            masMaritalStatusCode: dataInfo.masMaritalStatusCode,
            masMilitaryStatusCode: dataInfo.masMilitaryStatusCode,
            issuedDate: dataInfo.appissuedDate,
            expireDate: dataInfo.appexpireDate,
            issuedAt: dataInfo.appissuedAt,
            issuedProvince: dataInfo.appissuedProvince,
            hobby: dataInfo.apphobby,
            empFileUpload: dataInfo.appFileUpload,
            empGenius: dataInfo.appGenius,
            CREATE_USER: this.$session.getAll().data.userName,
            LAST_USER: this.$session.getAll().data.userName
          }
          console.log(dtInfo)
          this.CopyEmpInfo(dtInfo)

          this.CopyEmpAddress(this.dataAddress, response)
          this.CopyEmpFamily(this.dataFamily, response)
          this.CopyEmpEducation(this.dataEducation, response)
          this.CopyEmpExperince(this.dataExperince, response)
          this.CopyEmpCertificate(this.dataCertificate, response)
          this.CopyEmpLanguage(this.dataLanguage, response)
          this.CopyEmpComputer(this.dataComSkill, response)

          let dtJob = {
            empCode: response,
            startDate: this.date,
            empJobStatus: 'ดำเนินการ',
            positionName: AppInfo.positionName,
            positionTypeName: AppInfo.positionTypeName,
            masDepartmentName: AppInfo.masDepartmentName,
            masCompanyName: AppInfo.masCompanyName,
            masBranchName: AppInfo.masBranchName,
            CREATE_USER: this.$session.getAll().data.userName,
            LAST_USER: this.$session.getAll().data.userName
          }
          this.InsertJobExperience(dtJob)
          this.dataReady = true
        }
      )
    },
    async CopyEmpInfo (dtInfo) {
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/employee/" + "add",
          dtInfo,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          // Debug response
          console.log(response)
          if (response.status === 200) {
            this.dialog = false
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error function addDataGlobal : ', error)
          this.dataReady = true
        })
    },
    async CopyEmpAddress (dataAddress, empCode) {
      dataAddress.forEach(element => {
        let ds = {
          empCode: empCode,
          empAddressName: element.appAddressName,
          empAddessStatusMessenger: element.appAddessStatusMessenger,
          empAddressSubDistrict: element.appAddressSubDistrict,
          empAddressDistrict: element.appAddressDistrict,
          empAddressProvine: element.appAddressProvine,
          empAddressZipcode: element.appAddressZipcode,
          empAddressType: element.appAddressType,
          empAddressStatus: element.appAddressStatus,
          CREATE_USER: this.$session.getAll().data.userName,
          LAST_USER: this.$session.getAll().data.userName
        }
        axios
          .post(
          // eslint-disable-next-line quotes
            this.DNS_IP + "/employee_address/" + "add",
            ds,
            {
              headers: {
                'Application-Key': this.$session.getAll().ApplicationKey
              }
            }
          )
          .then(async (response) => {
          // Debug response
            if (response.status === 200) {
              this.dialog = false
            }
          })
        // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            console.log('error function addDataGlobal : ', error)
            this.dataReady = true
          })
      })
    },
    async CopyEmpFamily (dataFamily, empCode) {
      dataFamily.forEach(element => {
        let ds = {
          empCode: empCode,
          familyStatus: element.familyStatus,
          familyTitleName: element.familyTitleName,
          familyFirstName: element.familyFirstName,
          familyLastName: element.familyLastName,
          familyCareer: element.familyCareer,
          familyAddress: element.familyAddress,
          familyIdCard: element.familyIdCard,
          familyTel: element.familyTel,
          emergencyStatus: element.emergencyStatus,
          CREATE_USER: this.$session.getAll().data.userName,
          LAST_USER: this.$session.getAll().data.userName
        }
        axios
          .post(
            // eslint-disable-next-line quotes
            this.DNS_IP + "/employee_family/" + "add",
            ds,
            {
              headers: {
                'Application-Key': this.$session.getAll().ApplicationKey
              }
            }
          )
          .then(async (response) => {
            // Debug response
            if (response.status === 200) {
              this.dialog = false
            }
          })
          // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            console.log('error function addDataGlobal : ', error)
            this.dataReady = true
          })
      })
    },
    async CopyEmpEducation (dataEducation, empCode) {
      dataEducation.forEach(element => {
        let ds = {
          empCode: empCode,
          educationLevel: element.educationLevel,
          educationAddress: element.educationAddress,
          educationFaculty: element.educationFaculty,
          educationDepartment: element.educationDepartment,
          educationYear: element.educationYear,
          educationGrade: element.educationGrade,
          educationStatus: element.educationStatus,
          educationAcademyGroup: element.educationAcademyGroup,
          CREATE_USER: this.$session.getAll().data.userName,
          LAST_USER: this.$session.getAll().data.userName
        }
        axios
          .post(
            // eslint-disable-next-line quotes
            this.DNS_IP + "/employee_education/" + "add",
            ds,
            {
              headers: {
                'Application-Key': this.$session.getAll().ApplicationKey
              }
            }
          )
          .then(async (response) => {
            // Debug response
            if (response.status === 200) {
              this.dialog = false
            }
          })
          // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            console.log('error function addDataGlobal : ', error)
            this.dataReady = true
          })
      })
    },
    async CopyEmpExperince (dataExperince, empCode) {
      dataExperince.forEach(element => {
        let ds = {
          empCode: empCode,
          lastWorkExpName: element.lastWorkExpName,
          startDate: element.startDate,
          endDate: element.endDate,
          workExpAddress: element.workExpAddress,
          lastPosition: element.lastPosition,
          lastSalary: element.lastSalary,
          expSupervisor: element.expSupervisor,
          expSupervisorEmail: element.expSupervisorEmail,
          expSupervisorTel: element.expSupervisorTel,
          jobDescription: element.jobDescription,
          reasonResignation: element.reasonResignation,
          CREATE_USER: this.$session.getAll().data.userName,
          LAST_USER: this.$session.getAll().data.userName
        }
        axios
          .post(
            // eslint-disable-next-line quotes
            this.DNS_IP + "/emp_experience/" + "add",
            ds,
            {
              headers: {
                'Application-Key': this.$session.getAll().ApplicationKey
              }
            }
          )
          .then(async (response) => {
            // Debug response
            if (response.status === 200) {
              this.dialog = false
            }
          })
          // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            console.log('error function addDataGlobal : ', error)
            this.dataReady = true
          })
      })
    },
    async CopyEmpCertificate (dataCertificate, empCode) {
      dataCertificate.forEach(element => {
        let ds = {
          empCode: empCode,
          cerName: element.cerName,
          cerAddress: element.cerAddress,
          cerDateFrom: element.cerDateFrom,
          CREATE_USER: this.$session.getAll().data.userName,
          LAST_USER: this.$session.getAll().data.userName
        }
        axios
          .post(
            // eslint-disable-next-line quotes
            this.DNS_IP + "/employee_cer/" + "add",
            ds,
            {
              headers: {
                'Application-Key': this.$session.getAll().ApplicationKey
              }
            }
          )
          .then(async (response) => {
            // Debug response
            if (response.status === 200) {
              this.dialog = false
            }
          })
          // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            console.log('error function addDataGlobal : ', error)
            this.dataReady = true
          })
      })
    },
    async CopyEmpLanguage (dataLanguage, empCode) {
      dataLanguage.forEach(element => {
        let ds = {
          empCode: empCode,
          languageCode: element.languageCode,
          empLanguageRead: element.appLanguageRead,
          empLanguageSpeak: element.appLanguageSpeak,
          empLanguageWrite: element.appLanguageWrite,
          CREATE_USER: this.$session.getAll().data.userName,
          LAST_USER: this.$session.getAll().data.userName
        }
        axios
          .post(
            // eslint-disable-next-line quotes
            this.DNS_IP + "/employee_language_skill/" + "add",
            ds,
            {
              headers: {
                'Application-Key': this.$session.getAll().ApplicationKey
              }
            }
          )
          .then(async (response) => {
            // Debug response
            if (response.status === 200) {
              this.dialog = false
            }
          })
          // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            console.log('error function addDataGlobal : ', error)
            this.dataReady = true
          })
      })
    },
    async CopyEmpComputer (dataComSkill, empCode) {
      dataComSkill.forEach(element => {
        let ds = {
          empCode: empCode,
          masComputerSkillCode: element.masComputerSkillCode,
          empComputerSkillScore: element.appComputerSkillScore,
          empComputerSkillCer: element.appComputerSkillCer,
          empComputerSkillRemark: element.appComputerSkillRemark,
          empComputerSkillOrder: element.appComputerSkillOrder,
          CREATE_USER: this.$session.getAll().data.userName,
          LAST_USER: this.$session.getAll().data.userName
        }
        axios
          .post(
            // eslint-disable-next-line quotes
            this.DNS_IP + "/employee_computer_skill/" + "add",
            ds,
            {
              headers: {
                'Application-Key': this.$session.getAll().ApplicationKey
              }
            }
          )
          .then(async (response) => {
            // Debug response
            if (response.status === 200) {
              this.dialog = false
            }
          })
          // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            console.log('error function addDataGlobal : ', error)
            this.dataReady = true
          })
      })
    },
    async InsertJobExperience (ds) {
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/emp_job_experience/" + "add",
          ds,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          // Debug response
          if (response.status === 200) {
            this.dialog = false
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error function addDataGlobal : ', error)
          this.dataReady = true
        })
    },
    async getDataById (item) {
      await this.showDataInfo(item.applyId)
      await this.getDataByInfo(item.appCode)
      await this.getDataByAddress(item.appCode)
      await this.getDataByFamily(item.appCode)
      await this.getDataByEducation(item.appCode)
      await this.getDataByExperince(item.appCode)
      await this.getDataByCertificate(item.appCode)
      await this.getDataByLanguage(item.appCode)
      await this.getDataByComSkill(item.appCode)
    },
    async showDataInfo (item) {
      this.dataReady = false
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/application_apply/' + 'get?applyId=' + item,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.AppInfo = response.data[0]
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
        })
    },
    async getDataByInfo (item) {
      this.dataReady = false
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/application/" + "getExportByAppCode?appCode=" + item,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }

        )
        .then(async (response) => {
          if (response.data) {
            this.dataInfo = response.data
            Object.assign(this.dataInfo, response.data)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
        })
    },
    async getDataByAddress (item) {
      this.dataReady = false
      this.dataAddress = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/application_address/" + "getExportByAppCode?appCode=" + item,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }

        )
        .then(async (response) => {
          Object.assign(this.dataAddress, response.data)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
        })
    },
    async getDataByFamily (item) {
      this.dataReady = false
      this.dataFamily = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/application_family/" + "getExportByAppCode?appCode=" + item,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }

        )
        .then(async (response) => {
          this.dataReady = true
          if (response.data) {
            // this.dataFamily = response.data
            Object.assign(this.dataFamily, response.data)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
        })
    },
    async getDataByEducation (item) {
      this.dataReady = false
      this.dataEducation = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/application_education/" + "getExportByAppCode?appCode=" + item,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }

        )
        .then(async (response) => {
          this.dataReady = true
          if (response.data) {
            // this.dataEducation = response.data
            Object.assign(this.dataEducation, response.data)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
        })
    },
    async getDataByExperince (item) {
      this.dataReady = false
      this.dataExperince = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/application_experience/" + "getExportByAppCode?appCode=" + item,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }

        )
        .then(async (response) => {
          this.dataReady = true
          if (response.data) {
            // this.dataExperince = response.data
            Object.assign(this.dataExperince, response.data)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
        })
    },
    async getDataByCertificate (item) {
      this.dataReady = false
      this.dataCertificate = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/application_certificate/" + "getExportByAppCode?appCode=" + item,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }

        )
        .then(async (response) => {
          this.dataReady = true
          if (response.data) {
            // this.dataCertificate = response.data
            Object.assign(this.dataCertificate, response.data)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
        })
    },
    async getDataByLanguage (item) {
      this.dataReady = false
      this.dataLanguage = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/application_language_skill/" + "getExportByAppCode?appCode=" + item,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }

        )
        .then(async (response) => {
          this.dataReady = true
          if (response.data) {
            // this.dataLanguage = response.data
            Object.assign(this.dataLanguage, response.data)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
        })
    },
    async getDataByComSkill (item) {
      this.dataReady = false
      this.dataComSkill = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/application_computer_skill/" + "getExportByAppCode?appCode=" + item,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }

        )
        .then(async (response) => {
          this.dataReady = true
          if (response.data) {
            // this.dataComSkill = response.data
            Object.assign(this.dataComSkill, response.data)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
        })
    },
    //
    //
    //
    // Get Data All
    //
    //
    //
    async getDataByInfoAll () {
      this.dataReady = false
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/application_apply/" + "getExport",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          if (response.data) {
            Object.assign(this.dataInfoEx, response.data)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
        })
    },
    async getDataByAddressAll () {
      this.dataReady = false
      this.dataAddressEx = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/application_address/" + "getExport",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }

        )
        .then(async (response) => {
          this.dataReady = true
          if (response.data) {
            // this.dataAddressEx = response.data
            Object.assign(this.dataAddressEx, response.data)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
        })
    },
    async getDataByFamilyAll () {
      this.dataReady = false
      this.dataFamilyEx = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/application_family/" + "getExport",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }

        )
        .then(async (response) => {
          this.dataReady = true
          if (response.data) {
            // this.dataFamilyEx = response.data
            Object.assign(this.dataFamilyEx, response.data)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
        })
    },
    async getDataByEducationAll () {
      this.dataReady = false
      this.dataEducationEx = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/application_education/" + "getExport",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }

        )
        .then(async (response) => {
          this.dataReady = true
          if (response.data) {
            // this.dataEducation = response.data
            Object.assign(this.dataEducationEx, response.data)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
        })
    },
    async getDataByExperinceAll () {
      this.dataReady = false
      this.dataExperinceEx = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/application_experience/" + "getExport",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }

        )
        .then(async (response) => {
          this.dataReady = true
          if (response.data) {
            // this.dataExperince = response.data
            Object.assign(this.dataExperinceEx, response.data)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
        })
    },
    async getDataByCertificateAll () {
      this.dataReady = false
      this.dataCertificateEx = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/application_certificate/" + "getExport",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }

        )
        .then(async (response) => {
          this.dataReady = true
          if (response.data) {
            // this.dataCertificate = response.data
            Object.assign(this.dataCertificateEx, response.data)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
        })
    },
    async getDataByLanguageAll () {
      this.dataReady = false
      this.dataLanguageEx = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/application_language_skill/" + "getExport",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }

        )
        .then(async (response) => {
          this.dataReady = true
          if (response.data) {
            // this.dataLanguage = response.data
            Object.assign(this.dataLanguageEx, response.data)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
        })
    },
    async getDataByComSkillAll () {
      this.dataReady = false
      this.dataComSkillEx = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/application_computer_skill/" + "getExport",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }

        )
        .then(async (response) => {
          this.dataReady = true
          if (response.data) {
            // this.dataComSkill = response.data
            Object.assign(this.dataComSkillEx, response.data)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
        })
    }
  }
}
</script>
<style scope>
.Color-Font {
    color: #808588;
}
.Color-Font-Action {
    color: #B61C1C;
}
.Color-Font-Preview {
    color: #262A34;
}
.Color-Button {
    color: #B61C1C;
}
.Divider {
    border: 2px solid #808588;
    background: #808588;
    border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/Application/Applicant.vue